import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "app" };
const _hoisted_2 = { class: "main-content" };
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header),
                _createElementVNode("main", _hoisted_2, [
                    _createVNode(_component_router_view)
                ]),
                _createVNode(Footer)
            ]));
        };
    }
});
